module.exports = __webpack_public_path__ + "img/oval-green.2243dd83.svg";